import { BranchApiResponse } from './../../models/branch-api-response.model';
import { Subscription } from 'rxjs';
import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserAdminService } from './../../services/user-admin.service';
import { UsrInfo } from './../../models/usr-info.model';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { Branch } from './../../models/branch.model';
import { RolesService } from './../../services/roles.service';
import { BranchesService } from './../../services/branches.service';
import { Role } from '../../models/role.model';
import { RolesApiResponse } from '../../models/roles-api-response.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { NavigateService } from '../../services/navigate.service';

@Component({
  selector: 'app-admin-user-detail',
  templateUrl: './admin-user-detail.component.html',
  styleUrls: ['./admin-user-detail.component.scss']
})
export class AdminUserDetailComponent implements OnInit {
  rolesResp: RolesApiResponse;
  branchesResp: BranchApiResponse;
  email: string;
  user: UsrInfo;
  constructor(
    private activatedRoute: ActivatedRoute,
    private userAdminService: UserAdminService,
    public navigate: NavigateService,
    private rolesService: RolesService,
    private branchesService: BranchesService,
    public dialogRef: MatDialogRef<AdminUserDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick() {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.user = this.data.userInfo;
    this.rolesService.getRoles().subscribe(data => this.setupRoles(data));
    this.branchesService
      .getBranches()
      .subscribe(data => this.setupBranches(data));
  }

  setupRoles(rolesResp: RolesApiResponse) {
    for (const role of rolesResp.roles) {
      for (const userRole of this.user.roles) {
        if (role.roleName === userRole.roleName) {
          role.checked = true;
        }
      }
    }
    this.rolesResp = rolesResp;
  }

  setupBranches(branchesResp: BranchApiResponse) {
    for (const branch of branchesResp.branches) {
      for (const userBranch of this.user.branches) {
        if (branch.id === userBranch.id) {
          branch.checked = true;
        }
      }
    }
    this.branchesResp = branchesResp;
  }

  saveChanges() {
    const activeBranches = this.branchesResp.branches.filter(q => q.checked === true).map(p => p.id);
    const activeRoles = this.rolesResp.roles.filter(q => q.checked === true).map(p => p.roleName);
    this.userAdminService.updateUserInfo(this.user.email,
                                          this.user.status,
                                          this.user.userName,
                                          this.user.city,
                                          this.user.office).subscribe();
    this.userAdminService.saveUserInfo(activeRoles, activeBranches, this.user.email).subscribe(data => this.onNoClick());
  }
}
